<template>
  <div class="w-full relative h-64 photo" :style="`background: linear-gradient(rgba(0,0,0,.5), rgba(0,0,0,.5)), url(${postType === 'image' ? media : ''})`">
    <video v-if="postType === 'video'" autoplay muted loop id="myVideo" class="w-full h-64 object-cover">
            <source :src="media" type="video/mp4">
    </video>
     <div class="absolute bottom-6 left-5 md:left-16">
         <span class="font-semibold text-5xl text-white">{{currentPostDate}}</span>
         <div class="flex items-center mt-6">
             <div class="flex mr-5">
               <SocialMediaLogo v-show="facebookSelected" styles="static w-10 h-10" social="facebook"/>
               <SocialMediaLogo v-show="instagramSelected" styles="static w-10 h-10" social="instagram"/>
             </div>
             <InformationIcon class="mr-3"/>
             <p class="text-white text-light text-sm"><span class=" font-semibold">Created:</span>{{createdPostDate}}</p>
         </div>
     </div>
  </div>
</template>

<script>
import InformationIcon from "@/components/svg/Information";
import SocialMediaLogo from "@/components/shared/SocialMediaLogo";

import dayjs from 'dayjs';

var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

export default {
 name:"PostPhotoDetails",

 props: {
   media: {
     type: String,
     required: true
   },
   created: {
     type: String,
     required:true
   },
   postDate: {
     type: String,
     required:true
   },
   instagramSelected: {
     type: Boolean,
     required:true
   },
   facebookSelected: {
     type: Boolean,
     required:true
   },
   postType: {
     type: String,
     required:true
   },
 },

 computed: {
   currentPostDate: function() {
      if(!this.postDate) {
        return 'No date yet';
      }
      return dayjs(this.postDate).format('DD/MM/YYYY');
    },
    createdPostDate: function() {
      return dayjs(this.created).format('DD/MM/YYYY');
    }
 },

 components: {
     InformationIcon,
     SocialMediaLogo
 },
}
</script>

<style scoped>
.photo{
  background-repeat: no-repeat !important;
  background-size: cover !important
}
</style>